import React, {useState} from 'react';
// import Loader from '@components/framework/loader/Loader';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize
} from '@material-ui/core';
import {getConsentFormReview} from '@shared/services/AppointmentsServices';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSelector} from 'react-redux';
import {State} from '@shared/store/reducers/Index';
import {useTranslation} from 'react-i18next';
interface ReviewConsentFormDialogProps {
  open: boolean;
  appointmentId: number;
  // isLoading: boolean;
  onClose?: (response: string) => void;
  title?: string;
}
const ReviewConsentFormDialog = (
  props: ReviewConsentFormDialogProps
): React.ReactElement => {
  const {
    open,
    appointmentId,
    // isLoading,
    onClose
  } = props;
  const [consentNotes, setConsentNotes] = useState('');
  const groupId: any = useSelector((state: State) => state.auth.groupId);
  const selectedClinicId: any = useSelector(
    (state: State) => state.clinics.selectedClinicId || []
  );
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );
  const renderNotesTextArea = () => {
    return (
      <TextareaAutosize
        className="app-text-area"
        value={consentNotes}
        onChange={event => {
          setConsentNotes(event?.target?.value);
        }}
        rowsMax={10}
        rows={4}
        aria-label="maximum height"
      />
    );
  };

  // consent form Review API Integration
  const fetchConsentFormReview = async () => {
    try {
      const payload = {
        consent_review_notes: consentNotes
      };
      const response = await getConsentFormReview(
        groupId,
        selectedClinicId?.[0],
        appointmentId,
        payload
      );
      if (response) {
        handleClose('confirm');
        enqueueSnackbar(t('APPOINTMENTS.SUCCESS_MESSAGE'), SnackBarConfig('s'));
      }
    } catch (error: any) {
      enqueueSnackbar(
        error && error?.message,
        // || (error && error?.data[0]?.message)
        SnackBarConfig('e')
      );
    }
  };

  // **FIXME: need to render the HTML content inside the dialog content here **/
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={'sm'}
      fullWidth={true}
      open={open}
      onClose={handleClose}>
      <DialogTitle disableTypography>
        {t('APPOINTMENTS.CONSENT_FORM_REVIEW')}
      </DialogTitle>
      <DialogContent dividers>
        <div>{t('APPOINTMENTS.NOTES_OPTIONAL')}</div>
        {renderNotesTextArea()}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose('cancel')}>
          {t('APPOINTMENTS.CLOSE_BUTTON')}
        </Button>
        <Button
          onClick={() => fetchConsentFormReview()}
          color="primary"
          variant={'contained'}>
          {t('APPOINTMENTS.SUBMIT_BUTTON')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewConsentFormDialog;
